"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsonschema_1 = require("../../utils/jsonschema");
var schema = {
    $id: jsonschema_1.$id('stringExpression'),
    title: 'String expression',
    anyOf: [
        { type: 'string' },
        { type: 'null' },
        { $ref: jsonschema_1.$id('joinExpression') },
        { $ref: jsonschema_1.$id('splitExpression') },
        { $ref: jsonschema_1.$id('untypedResolvedExpression') }
    ]
};
exports.default = schema;
//# sourceMappingURL=string.schema.js.map